(() => {
  const SELECTOR = '[data-rk-proportional-section]';
  const INNER_SELECTOR = '[data-rk-proportional-inner]';
  const DESKTOP_MIN = 990;
  const MIN_SCALE = 0.35;

  let scheduled = false;
  let lastViewportWidth = window.innerWidth;

  function getPairs(root = document) {
    const nodes = [];
    if (root && root.matches && root.matches(SELECTOR)) nodes.push(root);
    if (root && root.querySelectorAll) nodes.push(...root.querySelectorAll(SELECTOR));
    return [...new Set(nodes)].map(section => ({
      section,
      inner: section.querySelector(INNER_SELECTOR)
    })).filter(item => item.inner);
  }

  function clearPairs(pairs) {
    for (const { section, inner } of pairs) {
      inner.style.transform = '';
      inner.style.transformOrigin = '';
      inner.style.marginBottom = '';
      section.style.paddingTop = '';
      section.style.paddingBottom = '';
      section.style.height = '';
      section.style.overflow = '';
      section.style.removeProperty('--rk-proportional-scale');
    }
  }

  function measurePairs(pairs) {
    if (window.innerWidth < DESKTOP_MIN) return [];

    const measured = [];
    for (const { section, inner } of pairs) {
      const target = Number.parseFloat(section.dataset.rkTargetHeight || '0');
      if (!target) continue;

      const style = window.getComputedStyle(section);
      const padTop = Number.parseFloat(style.paddingTop) || 0;
      const padBottom = Number.parseFloat(style.paddingBottom) || 0;
      const innerHeight = inner.getBoundingClientRect().height;
      if (!innerHeight) continue;

      const naturalHeight = padTop + innerHeight + padBottom;
      if (naturalHeight <= target + 1) continue;

      const scale = Math.max(MIN_SCALE, Math.min(1, target / naturalHeight));
      measured.push({ section, inner, target, padTop, padBottom, innerHeight, scale });
    }
    return measured;
  }

  function applyMeasurements(measured) {
    for (const { section, inner, padTop, padBottom, innerHeight, scale } of measured) {
      const visualInnerHeight = innerHeight * scale;
      const reduction = Math.max(0, innerHeight - visualInnerHeight);

      section.style.paddingTop = `${padTop * scale}px`;
      section.style.paddingBottom = `${padBottom * scale}px`;
      inner.style.transformOrigin = 'top center';
      inner.style.transform = `scale(${scale})`;
      inner.style.marginBottom = `${-reduction}px`;
      section.style.setProperty('--rk-proportional-scale', scale.toFixed(4));
    }
  }

  function fit(root = document) {
    const pairs = getPairs(root);
    if (!pairs.length) return;

    // Phase 1: all style writes are cleared together.
    clearPairs(pairs);

    // Phase 2/3: read every natural size first, then write every fitted size.
    // Keeping DOM reads and writes separated avoids the repeated forced reflows
    // of the former per-section implementation.
    requestAnimationFrame(() => {
      const measured = measurePairs(pairs);
      applyMeasurements(measured);
      scheduled = false;
    });
  }

  function schedule(root = document) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => fit(root));
  }

  function scheduleAll() {
    scheduled = false;
    schedule(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAll, { once: true });
  } else {
    scheduleAll();
  }

  window.addEventListener('load', scheduleAll, { once: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleAll).catch(() => {});
  }

  window.addEventListener('resize', () => {
    const width = window.innerWidth;
    if (Math.abs(width - lastViewportWidth) < 2) return;
    lastViewportWidth = width;
    scheduleAll();
  }, { passive: true });

  document.addEventListener('shopify:section:load', event => {
    scheduled = false;
    schedule(event.target);
  });
  document.addEventListener('shopify:section:reorder', scheduleAll);
  document.addEventListener('shopify:section:select', event => {
    scheduled = false;
    schedule(event.target);
  });
})();
